import { Pipe, PipeTransform, LOCALE_ID, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment-timezone';
import { ResolverService } from 'src/app/core';

@Pipe({
    name: 'date'
})
export class ExtendDatePipe extends DatePipe implements PipeTransform {
    constructor(
        @Inject(LOCALE_ID) locale: string,
        private resolvedService: ResolverService
    ) {
        super(locale);
    }
    transform(value: any, format = 'mediumDate', timezone?: string, locale?: string): any {
        if (value) {
            if (value.indexOf("T") != -1) {
                if (value.indexOf("Z") == -1) {
                    value = value + "Z";
                }

                let userTimezone = this.resolvedService.userInitInfo.profile.timezone_data;
                if (userTimezone) {
                    value = moment(value).tz(userTimezone.code).format('YYYY-MM-DDTHH:mm:ss');
                } else {
                    value = moment(value).utc().format('YYYY-MM-DDTHH:mm:ss');
                }
            }
        }

        return super.transform(value, format, timezone, locale);
    }
}
